import React, { PureComponent } from 'react';

import { Button } from 'components/button';
import { I18n } from 'components/translate';
import { PropTypes } from 'mobx-react';

import './File.scss';

export default class File extends PureComponent {
  fileRef = React.createRef();

  state = {
    file: null
  };

  static propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string
  };

  render() {
    const { file } = this.state;
    const { className = '' } = this.props;
    const classesFilename = 'flex-child filename__truncated label__description';
    const classesNonChosenFile = 'flex-child label__description';
    const hasFileName = file && file.name;
    const classLabelFile = hasFileName ? classesFilename : classesNonChosenFile;
    const classLabelContent = hasFileName ? (
      file.name
    ) : (
      <I18n label="general.no_file_chosen" />
    );

    return (
      <div className={`input__file ${className}`}>
        <label className={classLabelFile}>{classLabelContent}</label>

        <input type="file" ref={this.fileRef} onChange={this.onChange} />

        <Button
          className="input__file__button input__file_button--width flex-child"
          outline
          transparent
          onClick={this.onClick}
        >
          <I18n label="general.choose_file" />
        </Button>
      </div>
    );
  }

  onClick = () => {
    this.fileRef.current.click();
  };

  onChange = (event) => {
    const { onChange } = this.props;

    const file = event.target.files[0];

    this.setState({ file });

    onChange && onChange(file);
  };
}
